import axios from 'axios';

export class SquareService {

	/* Constants */
	sdkVersion = 'v2.0';
	tenderTypes = "com.squareup.pos.TENDER_CARD";

	/* Parameters */
	successCallback = function(){};
	// Error callback should take a bool, string parameters
	// shouldKeepUrl (bool) - whether or not to reload the page with the same url params
	// errorDescription (string) - description of the error
	errorCallback = function(shouldKeepUrl, errorDescription){};
	partyId = 0;

	/* Dynamic init definitions */
	transactionInfo = {};

	// possibly take party_id as parameter?
	constructor(partyId) {
		this.partyId = partyId
		// Set used params based on device type
		switch (this.getMobileOperatingSystem()) {
			default:
			case 'Android':
				this.getUrlParamsMethod = 'getUrlParamsAndroid';
				//If successful, Square Point of Sale returns the following parameters.
				this.clientTransactionIdString = "com.squareup.pos.CLIENT_TRANSACTION_ID";
				this.serverTransactionIdString = "com.squareup.pos.SERVER_TRANSACTION_ID";
				//If there's an error, Square Point of Sale returns the following parameters.
				this.errorFieldString = "com.squareup.pos.ERROR_CODE";
				this.errorDescriptionFieldString = "com.squareup.pos.ERROR_DESCRIPTION";
				break;
			// iOS is not supported at this time
			case 'iOS':
				this.getUrlParamsMethod = 'getUrlParamsIos';
				//If successful, Square Point of Sale returns the following parameters.
				this.clientTransactionIdString = "client_transaction_id";
				this.transactionIdString = "transaction_id";

				//If there's an error, Square Point of Sale returns the following parameters.
				this.errorFieldString = "error_code";
				// todo: double check
				this.errorDescriptionFieldString = "error_description";
				break;
		}
	}

	// Open Square app
	chargeAmount(transactionTotal) {
		// Make sure we have a valid charge amount
		transactionTotal = transactionTotal.toFixed(0);
		var posUrl =
			"intent:#Intent;" +
			"action=com.squareup.pos.action.CHARGE;" +
			"package=com.squareup;" +
			"S.com.squareup.pos.WEB_CALLBACK_URI=" + process.env.VUE_APP_SQUARE_CALLBACK_URL + ";" +
			"S.com.squareup.pos.CLIENT_ID=" + process.env.VUE_APP_SQUARE_APP_ID + ";" +
			"S.com.squareup.pos.API_VERSION=" + this.sdkVersion + ";" +
			"i.com.squareup.pos.TOTAL_AMOUNT=" + transactionTotal + ";" +
			"S.com.squareup.pos.CURRENCY_CODE=" + process.env.VUE_APP_SQUARE_CURRENCY_CODE + ";" +
			"S.com.squareup.pos.TENDER_TYPES=" + this.tenderTypes + ";" +
			"S.com.squareup.pos.AUTO_RETURN_TIMEOUT_MS=3200;" +
			"S.com.squareup.pos.NOTE=partyId: " + this.partyId + ";" +
			"end";

		window.open(posUrl);
	}

	// Main method
	async checkForSquareReturnAndAct(successCallback = function(){}, errorCallback = function(){}) {
		// Set callback functions
		this.successCallback = successCallback;
		this.errorCallback = errorCallback;

		if (!this.checkIfValidSquareReturn()) {
			return false;
		}
		return await this.handleResponse();
	}

	// Checks if there is valid square data in the URL
	checkIfValidSquareReturn() {
		const responseUrl = window.location.href;
		this.transactionInfo = this[this.getUrlParamsMethod](responseUrl);

		// Check if transactionInfo contains either valid response data (success or error)
		return [this.clientTransactionIdString, this.errorFieldString].some((element) => Object.keys(this.transactionInfo).includes(element));
	}

	// Determines whether error or success based on urlParams
	async handleResponse() {
		if (this.errorFieldString in this.transactionInfo) {
			// Square error
			this.handleError(this.transactionInfo);
			return false;
		}
		// Successful square sale
		await this.handleSuccess(this.transactionInfo);
		return true;
	}

	// Makes a result string for success situation
	async handleSuccess(transactionInfo){
		// confirm card payment on the backend
		axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('scanner_regkey');
		try {
			const ret = await axios.post(process.env.VUE_APP_API_SERVER+'/api/scannerdevice/party/'+this.partyId+'/confirm-card-payment', {
				check: `${localStorage.getItem('scanner_regkey')}`,
				server_txn_id: transactionInfo[this.serverTransactionIdString],
				client_txn_id: transactionInfo[this.clientTransactionIdString],
			});
			this.successCallback();
		} catch (err) {
			this.errorCallback(true, 'Error. Page will now refresh.\n\n If issue persists call Champion support.\n\n'+err.message);
			return false;
		}
		return true;
	}


	// Makes an error string for error situation
	handleError(transactionInfo){
		var resultString ="";

		if (this.errorDescriptionFieldString in transactionInfo) {
			resultString += "Error: " + decodeURI(transactionInfo[this.errorDescriptionFieldString]) + "\n";
		}
		if (this.clientTransactionIdString in transactionInfo) {
			resultString += "Client Transaction ID: " + transactionInfo[this.clientTransactionIdString] + "\n";
		}
		if (this.serverTransactionIdString in transactionInfo) {
			resultString += "Transaction ID: " + transactionInfo[this.serverTransactionIdString] + "\n";
		}

		// On error, display what the error is and refresh with no square params
		this.errorCallback(false, resultString);
	}

	// Used to convert the URL to proper params for android
	getUrlParamsAndroid(URL) {
		var vars = {};
		var parts = URL.replace(/[?&]+([^=&]+)=([^&]*)/gi,
			function(m,key,value) {
				vars[key] = value;
			});
		return vars;
	}

	// Used to convert the URL to proper params for ios
	getUrlParamsIos(URL) {
		try {
			URL = new window.URL(URL);
			var data = URL.searchParams.get("data");

			if (!data) {
				return {};
			}

			console.log("Square iOS response data received");
			var transactionInfo = JSON.parse(data);
			return transactionInfo;
		} catch (err) {
			return {};
		}
	}

	/**
	 * Determine the mobile operating system.
	 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
	 *
	 * https://stackoverflow.com/a/21742107
	 *
	 * @returns {String}
	 */
	getMobileOperatingSystem() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;

		// Windows Phone must come first because its UA also contains "Android"
		if (/windows phone/i.test(userAgent)) {
			return "Windows Phone";
		}

		if (/android/i.test(userAgent)) {
			return "Android";
		}

		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			return "iOS";
		}

		return "unknown";
	}
}
